// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1ac8a5e9] .el-dialog__body{text-align:center;color:#333}[data-v-1ac8a5e9] .el-dialog__body img{margin-top:14px}[data-v-1ac8a5e9] .el-dialog__body h2{margin:30px 0 10px 0;font-size:16px;font-weight:600}[data-v-1ac8a5e9] .el-dialog__body p{font-size:14px;margin-bottom:14px}[data-v-1ac8a5e9] .el-dialog__header .el-dialog__title{font-size:16px;color:#333;font-weight:600}", ""]);
// Exports
module.exports = exports;
